import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../lib/shop';

const ShopConfigContext = createContext({ live: false, loading: true, refresh: () => {} });

export const ShopConfigProvider = ({ children }) => {
  const [state, setState] = useState({ live: false, loading: true });

  const refresh = useCallback(() => {
    return axios.get(`${API}/shop/config`)
      .then(r => setState({ live: !!r.data.live, loading: false }))
      .catch(() => setState({ live: false, loading: false }));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <ShopConfigContext.Provider value={{ ...state, refresh }}>{children}</ShopConfigContext.Provider>;
};

export const useShopConfig = () => useContext(ShopConfigContext);
